import formEditApi from '@/api/customer_edit/formEditApi'
import FormData from '@/classes/form/FormData'
import FormDescriptor from '@/classes/form/FormDescriptor'
import customerApi from '@/api/customer/customerApi'

const state = {
  CustomerEditFormDescriptors: [],
  CustomerEditFormDatas: []
}

const mutations = {
  setStateEditFormDescriptors: (state, data) => {
    state.CustomerEditFormDescriptors = FormDescriptor.asFormDescriptors(data)
  },
  setStateEditFormDatas: (state, data) => {
    state.CustomerEditFormDatas = FormData.initiateFormDatas(state.CustomerEditFormDescriptors)
    FormData.loadInitialFormDatas(data, state.CustomerEditFormDatas)
    FormDescriptor.checkFormDescriptorsDependencies(state.CustomerEditFormDescriptors, state.CustomerEditFormDatas)
  }
}

const actions = {
  setupCustomerEditForm ({ commit, state }, profileId) {
    return formEditApi.getCustomerEditForm(profileId).then((response) => {
      commit('setStateEditFormDescriptors', [response.data])
      commit('setStateEditFormDatas', [response.data.form_data])
      return true
    }).catch((err) => {
      throw err
    })
  },
  setupCustomerUpdateInvoiceInformationForm ({ commit, state }, profileId) {
    return customerApi.getCustomerUpdateInvoiceInformationForm(profileId).then((response) => {
      commit('setStateEditFormDescriptors', [response.data])
      commit('setStateEditFormDatas', [response.data.form_data])
      return true
    }).catch((err) => {
      throw err
    })
  },
  setupCustomerNewInvoiceInformationForm ({ commit, state }, profileId) {
    return customerApi.getCustomerNewInvoiceInformationForm(profileId).then((response) => {
      commit('setStateEditFormDescriptors', [response.data])
      console.log(response.data.form_data)
      commit('setStateEditFormDatas', [response.data.form_data])
      return true
    }).catch((err) => {
      throw err
    })
  },
  updateCustomerInformation ({ commit }, requestData) {
    return formEditApi.patchCustomerInformation(requestData.data.profileId, requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  updateCustomerInvoiceInformation ({ commit }, requestData) {
    return customerApi.patchCustomerInvoiceInformation(requestData.data.profileId, requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  }
}

export default {
  state,
  mutations,
  actions
}
